<template>
  <b-modal no-fade v-model="dialog.show" size="sm"  :id="`modal-clientStatus-${uniqueId}`"
           :hide-footer="true" centered @close="onDialogClose"
           no-close-on-backdrop
  >
    <div style="min-height: 500px">
      <div v-if="loading !== true && error == null">
        <clientStatus-edit-details v-bind:new-clientStatus="isNewClientStatus" v-model="clientStatus" @input="closeModal" />
      </div>
      <div class="text-center position-absolute d-block w-100" style="top:50%" v-else-if="loading !== true && error != null">
        <b-alert show variant="danger" >
          <i class="fa-sharp fa-solid fa-triangle-exclamation"></i>
          {{ error }}
        </b-alert>
      </div>
      <div class="text-center position-absolute d-block w-100" style="top:50%" v-else>
        <b-spinner>{{$t('operations.loading')}}</b-spinner>
      </div>
    </div>
  </b-modal>
</template>

<script>
import mixinBase from '@/components/mixin/mixinBase'
import mixinNotifications from '@/components/mixin/mixinNotifications'
import { mapActions } from 'vuex'
import ClientStatusEditDetails from '@/components/partial/clientStatus/ClientStatusEditDetails'
import ClientStatus from '@/model/clientStatus/ClientStatus'

export default {
  name: 'clientStatusModal',
  components: { ClientStatusEditDetails },
  mixins: [mixinBase, mixinNotifications],
  data: () => ({
    dialog: {
      show: false,
    },
    uniqueId: 0,
    loading: true,
    error: null,
    id: null,
    isNewClientStatus: false,
    clientStatus: {}
  }),
  watch: {
    queryParams:{
      handler(){
        if(this.queryParams().clientStatusId == null) {
          this.closeModal()
          return
        }
        if (this.queryParams().clientStatusId !== this.id) {
          this.showModal(this.queryParams().clientStatusId)
        }
      },
      deep: true
    }
  },
  created() {
    this.uniqueId = this._uid
    if(this.queryParams().clientStatusId != null) {
      this.showModal(this.queryParams().clientStatusId)
    }
  },
  methods: {
    ...mapActions('clientStatus', ['getClientStatusById']),
    showModal(id) {
      this.id = id
      this.loading = true
      this.dialog.show = true
      this.dialog.tab = 0
      this.isNewClientStatus = this.id == null || this.id === 0;
      if(!this.isNewClientStatus) {
        this.refreshData()
      }else {
        this.clientStatus = ClientStatus()
        this.error = null
        this.loading = false
      }
      this.pushState({clientStatusId: id, tab: 0, })
    },
    closeModal(){
      this.dialog.show = false;
      this.clientStatus = {}
      this.onDialogClose()
    },
    onDialogClose(){
      this.id = null;
      this.pushState({clientStatusId: null, tab: null, })
    },
    refreshData() {
      let $this = this;
      this.getClientStatusById(this.id)
          .then(clientStatus => {
            $this.clientStatus = clientStatus;
            $this.error = null
            $this.loading = false
          }, err => {
            $this.error = $this.getErrorDescription(err)
            $this.loading = false
          })
    },
  }
}
</script>

<style scoped>

</style>
